const filterReducer = (activeFilter = null, action) => {
    switch(action.type) {
        case 'SET_FILTER':
            return action.payload;
        default:
            return activeFilter;
    }
};

export default filterReducer;